<div class="fontsize">
    @if (ContextService?.IsUserLoggedIn && ContextService?.IsRecruiter) {
    <div class="mySearch" style="cursor: pointer;" data-toggle="collapse" data-target="#mySearch" aria-expanded="false"
        aria-controls="MySearch" (click)="SearchToggle($event)">My Search
        @if (SearchState) {
        <i class="fa fa-angle-up float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#mySearch"
            aria-expanded="false" aria-controls="MySearch" (click)="SearchToggle($event)"></i>
        }@else {
        <i class="fa fa-angle-down float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#mySearch"
            aria-expanded="false" aria-controls="MySearch" (click)="SearchToggle($event)"></i>
        }
    </div>
    <div class="collapse mt-2 mb-3" id="mySearch" [class.show]="SearchState">
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.JobPost">Post Job</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyCVShortList">Shortlists</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyAutoSearches">Auto Searches</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.ManageJobs">Manage Job</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyRecentApplications">Applications</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyNetwork">Connections</a>
    </div>

    <div class="dropdown-divider ml-2 mr-2"></div>
    <div class="myCvs" style="cursor: pointer;" data-toggle="collapse" data-target="#myCVs" aria-expanded="false"
        aria-controls="MySearch" (click)="CVsToggle($event)">My Cvs
        @if (CVsState) {
        <i class="fa fa-angle-up float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#myCVs"
            aria-expanded="false" aria-controls="MySearch" (click)="CVsToggle($event)"></i>
        } @else {
        <i class="fa fa-angle-down float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#myCVs"
            aria-expanded="false" aria-controls="MySearch" (click)="CVsToggle($event)"></i>
        }
    </div>
    <div class="collapse mt-2 mb-3" id="myCVs" [class.show]="CVsState">
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyScreenedCVs">Search4Me</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.RecommendedCVs">Recommended
            CVs</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.CVNearMe">CVs Near Me</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.HiddenCVs">Hidden CVs</a>
        <a class="dropdown-item custom-dropdown-item" *ngIf="ContextService?.IsApply4UAdmin" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.DispatchRecommendations">Dispatch
            Recommendations</a>
    </div>

    } @else {

    <div class="mySearch" style="cursor: pointer;" data-toggle="collapse" data-target="#mySearch" aria-expanded="false"
        aria-controls="MySearch" (click)="SearchToggle($event)">My Search
        @if (SearchState) {
        <i class="fa fa-angle-up float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#mySearch"
            aria-expanded="false" aria-controls="MySearch" (click)="SearchToggle($event)"></i>
        } @else {
        <i class="fa fa-angle-down float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#mySearch"
            aria-expanded="false" aria-controls="MySearch" (click)="SearchToggle($event)"></i>
        }
    </div>
    <div class="collapse mt-2 mb-3" id="mySearch" [class.show]="SearchState">
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyJobsApplications">Applications</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyJobShortLists">Shortlists</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyAutoSearches">Auto Searches</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.MyNetwork">Connections</a>
    </div>

    <div class="dropdown-divider ml-2 mr-2"></div>
    <div class="myJobs" style="cursor: pointer;" data-toggle="collapse" data-target="#myJobs" aria-expanded="false"
        aria-controls="MySearch" (click)="JobsToggle($event)">My Jobs
        @if (JobsState) {
        <i class="fa fa-angle-up float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#myJobs"
            aria-expanded="false" aria-controls="MySearch" (click)="JobsToggle($event)"></i>
        } @else {
        <i class="fa fa-angle-down float-right" style="cursor: pointer;" data-toggle="collapse" data-target="#myJobs"
            aria-expanded="false" aria-controls="MySearch" (click)="JobsToggle($event)"></i>
        }
    </div>
    <div class="collapse mt-2 mb-3" id="myJobs" [class.show]="JobsState">
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.HiddenJobs">Hidden Jobs</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.RecommendedJobs">Recommended
            Jobs</a>
        <a class="dropdown-item custom-dropdown-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" [routerLink]="Navigations.JobNearMe">Jobs Near Me</a>
    </div>
    }
</div>